import { useEffect, useState } from "react";
import styles from "./add.module.css";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField, Table, TableCell, TableHead, TableContainer, Paper, TableBody, TableRow, Snackbar, Alert, Dialog, Checkbox, InputAdornment, IconButton } from "@mui/material";
import { ClearRounded, SearchOutlined } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { authData, withAdminAuth } from "../../components/GetAuth";
import Loader from "../../components/Loader";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import WHItemListCustomRow from "./components/WHItemListCustomRow";
import ConItemListCustomRow from "./components/ConItemListCustomRow";
import { StyledMainTableCell } from "../../components/TableComponent";
import { Calendar } from "react-feather";
import { DateRangePicker } from "rsuite";
import PageHeader from "../../components/PageHeader";
import { useWebsite } from "../../../context/WebsiteContext";
import { useSiteBranding } from "../../../hooks/useSiteBranding";
import AddContainerForm from "../../components/popups/AddContainerForm";

// Shared field styling for every text/select/date input in the top
// form. Kept as an `sx` object (rather than a CSS-module class) so it
// can safely reach into MUI's own internal, unscoped classnames
// (.MuiOutlinedInput-root, .Mui-focused, etc.) without ever writing a
// global CSS selector.
const fieldSx = {
  width: "100%",

  "& .MuiOutlinedInput-root": {
    height: 48,
    borderRadius: "10px",
    backgroundColor: "#fff",
    fontSize: "14px",
    transition: "all .2s ease",

    "& fieldset": {
      borderColor: "#d8dbe2",
    },

    "&:hover fieldset": {
      borderColor: "#ef233c99",
    },

    "&.Mui-focused fieldset": {
      borderColor: "#ef233c",
      borderWidth: "2px",
    },

    "&.Mui-focused": {
      boxShadow: "0 0 0 3px rgba(239,35,60,.12)",
    },
  },

  "& .MuiOutlinedInput-input": {
    padding: "13px 14px",
    fontSize: "14px",
    color: "#22252f",
  },

  "& .MuiSelect-select": {
    padding: "13px 14px !important",
    display: "flex",
    alignItems: "center",
  },

  "& .MuiInputLabel-root": {
    color: "#8a8f98",
    fontSize: "14px",
    transform: "translate(14px, 13px) scale(1)",
    transition: "all .2s ease",
  },

  "& .MuiInputLabel-root.Mui-focused": {
    color: "#ef233c",
  },

  "& .MuiInputLabel-root.MuiInputLabel-shrink": {
    transform: "translate(14px, -9px) scale(0.75)",
    backgroundColor: "#fff",
    padding: "0 6px",
    color: "#ef233c",
  },

  "& .MuiInputBase-input::placeholder": {
    color: "#b0b4bc",
    opacity: 1,
  },

  "& .MuiSvgIcon-root": {
    color: "#9ca3af",
  },

  "& .Mui-disabled": {
    WebkitTextFillColor: "#5e6278",
    backgroundColor: "#f8f9fb",
  },

  "& .MuiOutlinedInput-root.Mui-disabled fieldset": {
    borderColor: "#e5e7eb",
  },
};

const AddShipping = ({ history, match }) => {
  const auth = authData();
  const navigate = useNavigate();
  const { shippingId } = useParams();
  const [loading, setLoading] = useState(false);
  const [WHItems, setWHItems] = useState([]);
  const [WHFilterItems, setWHFilterItems] = useState([]);
  const [containerItems, setContainerItems] = useState([]);
  const [containerFilterItems, setContainerFilterItems] = useState([]);
  const [containerId, setContainerId] = useState(0);
  const [formOpen, setFormOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMsg, setSnackMsg] = useState('Please select container first!!');
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [shippingData, setShippingData] = useState(null);
  const [containerList, setContainerList] = useState([]);
  const [isDisabled, setIsDisabled] = useState("");
  const [filterVars1, setFilterVars1] = useState({ searchKey: "", date: null });
  const [filterVars2, setFilterVars2] = useState({ searchKey: "", date: null });
  const [selected1, setSelected1] = useState([]);
  const [selected2, setSelected2] = useState([]);

  const { websiteData } = useWebsite();
  useSiteBranding(shippingId ? 'View Shipping' : 'Add Shipping', websiteData);

  const { register, handleSubmit, control, formState: { errors }, setValue } = useForm({
    mode: "onChange",
    defaultValues: {
      container_no: "",
      shipping_from: "",
      shipping_to: "",
      consignee: "",
      warehouse_location: "",
    }
  });

  useEffect(() => {
    let isAdd = 1;
    if (shippingId) {
      setIsDisabled("disabled");
      isAdd = 0;
    }
    axios.get(process.env.REACT_APP_API_URL + "v1/container-dd-list/" + isAdd, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setContainerList(response.data.data);
      }
    });
  }, [shippingId, auth?.api_token]);

  useEffect(() => {
    if (shippingId) {
      axios.get(process.env.REACT_APP_API_URL + "v1/shippings/" + shippingId, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        }
      }).then((response) => {
        if (response.data.status === "SUCCESS") {
          let shipData = response.data.data;
          setShippingData(shipData);
          setValue("shipping_from", shipData?.shipping_from);
          setValue("shipping_to", shipData?.shipping_to);
          setValue("shipping_date", dayjs(shipData?.shipping_date));
          setValue("eta_of_container", dayjs(shipData?.eta_of_container));
          setValue("consignee", shipData?.consignee);
          setValue("warehouse_location", shipData?.warehouse_location);
          setValue("container_no", shipData?.container_no);
          setContainerId(shipData?.container_no);
        }
      });
    }
  }, [shippingId, containerList, setValue, auth?.api_token]);

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-wh", {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setWHItems(response.data.data);
      }
    });
  }, [auth?.api_token]);

  useEffect(() => {
    let filterredTempData = WHItems;

    if (filterVars1?.searchKey !== "") {
      let inputVal = filterVars1?.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredTempData = filterredTempData.filter((item) => {
        return (item.booking_id.toLowerCase().includes(inputVal));
      });
    }

    if (filterVars1?.date) {
      filterredTempData = filterredTempData.filter((i) => dayjs(i?.pickup_date).isBetween(dayjs(filterVars1?.date[0]).format("YYYY-MM-DD"), dayjs(filterVars1?.date[1]).format("YYYY-MM-DD"), "day", "[]"));
    }

    setWHFilterItems(filterredTempData);
  }, [WHItems, filterVars1]);

  useEffect(() => {
    if (containerId) {
      axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-con/" + containerId, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        }
      }).then((response) => {
        if (response.data.status === "SUCCESS") {
          setContainerItems(response.data.data);
        }
      });
    }
  }, [containerId, auth?.api_token]);

  const onSubmit = (data) => {
    setLoading(true);
    let postData = { container_no: data.container_no };
    if (data?.consignee !== "") {
      postData = { ...postData, consignee: data?.consignee };
    }
    if (data?.eta_of_container !== "") {
      postData = { ...postData, eta_of_container: dayjs(data?.eta_of_container).format("YYYY-MM-DD") };
    }
    if (data?.shipping_date !== "") {
      postData = { ...postData, shipping_date: dayjs(data?.shipping_date).format("YYYY-MM-DD") };
    }
    if (data?.shipping_from !== "") {
      postData = { ...postData, shipping_from: data?.shipping_from };
    }
    if (data?.shipping_to !== "") {
      postData = { ...postData, shipping_to: data?.shipping_to };
    }
    if (data?.warehouse_location) {
      postData = { ...postData, warehouse_location: data?.warehouse_location };
    }

    if (shippingId) {
      return axios.post(process.env.REACT_APP_API_URL + "v1/shippings/" + shippingId, postData, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          navigate("/shipping/list");
        }
      }).catch((error) => {
        setLoading(false);
      });
    } else {
      return axios.post(process.env.REACT_APP_API_URL + "v1/shippings", postData, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          navigate("/shipping/list");
        }
      }).catch((error) => {
        setLoading(false);
      });
    }
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackOpen(false);
  }

  const cancelShip = () => {
    navigate("/shipping/list");
  }

  const cancelShipping = () => {
    axios.get(process.env.REACT_APP_API_URL + "v1/cancel-shipping/" + shippingId, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        navigate("/shipping/list");
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  const markedContainer = () => {
    setLoading(true);
    axios.get(process.env.REACT_APP_API_URL + "v1/marked-container/" + shippingId, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        navigate("/shipping/list");
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  const addToContainer = (bookingData) => {
    if (containerId === 0) {
      setSnackMsg('Please select container first!!');
      setSnackOpen(true);
      return false;
    }

    let bookingId = bookingData?.id;
    axios.get(process.env.REACT_APP_API_URL + "v1/item-loaded/" + containerId + "/" + bookingId, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-con/" + containerId, {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            setContainerItems(response.data.data);
          }
        });
        axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-wh", {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            setWHItems(response.data.data);
          }
        });
      }
    });
  }

  const addToContainer2 = (bookingData) => {
    if (containerId === 0) {
      setSnackMsg('Please select container first!!');
      setSnackOpen(true);
      return false;
    }
    let bookingPId = bookingData?.id;
    let bookingId = bookingData?.booking_id;

    axios.get(process.env.REACT_APP_API_URL + "v1/item-loaded/" + containerId + "/" + bookingId + "/" + bookingPId, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-con/" + containerId, {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            setContainerItems(response.data.data);
          }
        });
        axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-wh", {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            setWHItems(response.data.data);
          }
        });
      }
    });
  }

  const removeToContainer = (bookingData) => {
    let bookingId = bookingData?.id;
    axios.get(process.env.REACT_APP_API_URL + "v1/item-unloaded/" + containerId + "/" + bookingId, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-con/" + containerId, {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            setContainerItems(response.data.data);
          }
        });
        axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-wh", {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            setWHItems(response.data.data);
          }
        });
      }
    });
  }

  const removeToContainer2 = (bookingData) => {
    if (containerId === 0) {
      setSnackMsg('Please select container first!!');
      setSnackOpen(true);
      return false;
    }
    let bookingPId = bookingData?.id;
    let bookingId = bookingData?.booking_id;

    axios.get(process.env.REACT_APP_API_URL + "v1/item-unloaded/" + containerId + "/" + bookingId + "/" + bookingPId, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-con/" + containerId, {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            setContainerItems(response.data.data);
          }
        });
        axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-wh", {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            setWHItems(response.data.data);
          }
        });
      }
    });
  }

  useEffect(() => {
    let containerItemsTemp = containerItems;

    if (filterVars2?.searchKey !== "") {
      let inputVal = filterVars2?.searchKey;
      inputVal = inputVal.toLowerCase();
      containerItemsTemp = containerItemsTemp.filter((item) => {
        return (item.booking_id.toLowerCase().includes(inputVal));
      });
    }

    if (filterVars2?.date) {
      containerItemsTemp = containerItemsTemp.filter((i) => dayjs(i?.pickup_date).isBetween(dayjs(filterVars2?.date[0]).format("YYYY-MM-DD"), dayjs(filterVars2?.date[1]).format("YYYY-MM-DD"), "day", "[]"));
    }

    setContainerFilterItems(containerItemsTemp);
  }, [containerItems, filterVars2]);

  const onSubmitAddContainerForm = (data) => {
    let containerItemsTemp1 = containerList;
    containerItemsTemp1.push(data);
    setContainerList(containerItemsTemp1);
    setValue(`container_no`, data?.id);
  }

  const selectRowEvent1 = (id) => {
    const selectedIndex = selected1.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected1, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected1.slice(1));
    } else if (selectedIndex === selected1.length - 1) {
      newSelected = newSelected.concat(selected1.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected1.slice(0, selectedIndex), selected1.slice(selectedIndex + 1));
    }
    setSelected1(newSelected);
  }

  const selectRowEvent2 = (id) => {
    const selectedIndex = selected2.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected2, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected2.slice(1));
    } else if (selectedIndex === selected1.length - 1) {
      newSelected = newSelected.concat(selected2.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected2.slice(0, selectedIndex), selected2.slice(selectedIndex + 1));
    }
    setSelected2(newSelected);
  }

  const addItemByBookingId = () => {
    if (containerId === 0) {
      setSnackMsg('Please select container first!!');
      setSnackOpen(true);
      return false;
    }

    if (selected1.length === 0) {
      setSnackMsg('Please select booking first!!');
      setSnackOpen(true);
      return false;
    }

    let postData = { bookingIds: selected1, containerId: containerId };
    axios.post(process.env.REACT_APP_API_URL + "v1/item-loaded-by-book-id", postData, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-con/" + containerId, {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            setContainerItems(response.data.data);
          }
        });
        axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-wh", {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            setWHItems(response.data.data);
          }
        });
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  const removeItemByBookingId = () => {
    if (containerId === 0) {
      setSnackMsg('Please select container first!!');
      setSnackOpen(true);
      return false;
    }

    if (selected2.length === 0) {
      setSnackMsg('Please select booking first!!');
      setSnackOpen(true);
      return false;
    }

    let postData = { bookingIds: selected2, containerId: containerId };
    axios.post(process.env.REACT_APP_API_URL + "v1/item-unloaded-by-book-id", postData, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-con/" + containerId, {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            setContainerItems(response.data.data);
          }
        });
        axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-wh", {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            setWHItems(response.data.data);
          }
        });
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  return (<>
    {loading && <Loader />}
    <div className={`${styles.MainDiv}`}>
      <PageHeader title="Shipping" trail={[{ label: shippingId ? 'View' : 'Add' }]} />

      <div className={`${styles.MainCard}`}>
        <div className={`${styles.StepOneForm}`}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div className={`${styles.FormRowFlex}`}>
                <div className={`${styles.ColContainer}`}>
                  <div className={`${styles.FieldWrap}`}>
                    <FormControl fullWidth disabled={isDisabled}>
                      <InputLabel>Container*</InputLabel>
                      <Controller
                        control={control}
                        {...register("container_no", { required: "Please select container_no" })}
                        render={({ field }) => (<Select
                          label="Container*"
                          sx={fieldSx}
                          {...field}
                          onChange={(e) => {
                            field.onChange(e);
                            setContainerId(e?.target?.value);
                          }}
                        >
                          {containerList?.map((val) => {
                            return (<MenuItem key={val?.value} value={val?.value}>{val?.label}</MenuItem>);
                          })}
                        </Select>)}
                      />
                    </FormControl>
                    <Button type="button" onClick={(e) => { setFormOpen(true); setEditData(null); }} className={`${styles.AddBU}`}>Add</Button>
                  </div>
                  {errors.container_no && (<span className={`${styles.ErrorM}`}>{errors?.container_no?.message}</span>)}
                </div>

                <div className={`${styles.ColField}`}>
                  <Controller
                    control={control}
                    {...register("shipping_from", { required: "This field is Required" })}
                    render={({ field }) => (<TextField {...field} sx={fieldSx} fullWidth label="Shipping From*" variant="outlined" />)}
                  />
                  {errors.shipping_from && (<span className={`${styles.ErrorM}`}>{errors?.shipping_from?.message}</span>)}
                </div>
                <div className={`${styles.ColField}`}>
                  <Controller
                    control={control}
                    {...register("shipping_to", { required: "This field is Required" })}
                    render={({ field }) => (<TextField {...field} sx={fieldSx} fullWidth label="Shipping To*" variant="outlined" />)}
                  />
                  {errors.shipping_to && (<span className={`${styles.ErrorM}`}>{errors?.shipping_to?.message}</span>)}
                </div>
              </div>
              <div className={`${styles.FormRowFlex}`} style={{ marginTop: 20 }}>
                <div className={`${styles.ColField}`}>
                  <Controller
                    control={control}
                    {...register("shipping_date", { required: "Please select shipping date" })}
                    render={({ field }) => (<DatePicker {...field} minDate={dayjs()} format="DD/MM/YYYY" label="Shipping Date" sx={fieldSx} />)}
                  />
                  {errors?.shipping_date && (<span className={`${styles.ErrorM}`}>{errors?.shipping_date?.message}</span>)}
                </div>
                <div className={`${styles.ColField}`}>
                  <Controller
                    control={control}
                    {...register("eta_of_container", { required: "Please select Eta Of Container date" })}
                    render={({ field }) => (<DatePicker {...field} minDate={dayjs()} format="DD/MM/YYYY" label="Eta Of Container" sx={fieldSx} />)}
                  />
                  {errors.eta_of_container && (<span className={`${styles.ErrorM}`}>{errors?.eta_of_container?.message}</span>)}
                </div>
                <div className={`${styles.ColField}`}>
                  <Controller
                    control={control}
                    {...register("consignee", { required: "This field is Required" })}
                    render={({ field }) => (<TextField {...field} sx={fieldSx} fullWidth label="Consignee*" variant="outlined" />)}
                  />
                  {errors.consignee && (<span className={`${styles.ErrorM}`}>{errors?.consignee?.message}</span>)}
                </div>
                <div className={`${styles.ColField}`}>
                  <Controller
                    control={control}
                    {...register("warehouse_location", { required: "This field is Required" })}
                    render={({ field }) => (<TextField {...field} sx={fieldSx} fullWidth label="Warehouse Location*" variant="outlined" />)}
                  />
                  {errors.warehouse_location && (<span className={`${styles.ErrorM}`}>{errors?.warehouse_location?.message}</span>)}
                </div>
              </div>
              <div className={`${styles.StepBUSec}`}>
                <button className={`${styles.Next}`} type="submit">Save</button>
                <button className={`${styles.Next3}`} type="button" onClick={cancelShip}>Cancel</button>
                <Button className={`${styles.Next2}`} type="button" disabled={!shippingData || (shippingData && (shippingData?.status === 1 || shippingData?.status === "1" || shippingData?.status === 2 || shippingData?.status === "2"))} onClick={markedContainer.bind(this)}>Marked Container As Shipped</Button>
                <Button className={`${styles.Next2}`} type="button" disabled={!shippingData || (shippingData && (shippingData?.status === 1 || shippingData?.status === "1" || shippingData?.status === 2 || shippingData?.status === "2"))} onClick={cancelShipping}>Cancel Shipping</Button>
              </div>
            </LocalizationProvider>
          </form>
        </div>
      </div>

      <div className={`${styles.MainCard}`} style={{ background: 'none', padding: 0, border: 'none', boxShadow: 'none' }}>
        <div className={`${styles.MainCard2Half} ${styles.MainCard2Half1}`}>
          <p>Item In UK Warehouse</p>

          <div className={`${styles.TableFilterHead}`}>
            <div className={`${styles.SearchBox}`}>
              <TextField
                fullWidth
                placeholder="Search reference, container, forwarder, address or contact..."
                value={filterVars1?.searchKey}
                onChange={(e) => setFilterVars1((prev) => { return { ...prev, searchKey: e.target.value }; })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchOutlined className={styles.SearchIcon} />
                    </InputAdornment>
                  ),
                  endAdornment: filterVars1?.searchKey && (
                    <InputAdornment position="end">
                      <IconButton size="small" aria-label="Clear search" onClick={(e) => setFilterVars1((prev) => { return { ...prev, searchKey: "" }; })}>
                        <ClearRounded fontSize="small" className={styles.ClearButton} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            <div className={styles.DateFilterWrap}>
              <DateRangePicker
                format={"dd/MM/yyyy"}
                placement={"bottomEnd"}
                placeholder="Serach by date"
                caretAs={Calendar}
                value={filterVars1?.date}
                showOneCalendar onChange={(e) => setFilterVars1((prev) => { return { ...prev, date: e }; })}
              />
            </div>

            <div className={`${styles.FilerButton}`}>
              <Button className={`${styles.TableAddBU}`} onClick={(e) => addItemByBookingId()}>Add All</Button>
            </div>
          </div>

          <div className={`${styles.CusTable}`}>
            <TableContainer component={Paper} elevation={0}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledMainTableCell padding="checkbox" style={{ padding: '12px 0', width: '34px' }}>
                      <Checkbox
                        className={`${styles.AllCheckbox}`}
                        color="primary"
                        indeterminate={selected1?.length > 0 && selected1?.length < WHFilterItems?.length}
                        checked={WHFilterItems?.length > 0 && selected1?.length === WHFilterItems?.length}
                        onChange={(e) => {
                          if (e.target.checked) {
                            const newSelected = WHFilterItems.map((n) => n.id);
                            setSelected1(newSelected);
                            return;
                          }
                          setSelected1([]);
                        }}
                      />
                    </StyledMainTableCell>
                    <StyledMainTableCell style={{ padding: '12px 2px', textAlign: 'center' }}>Booking Id</StyledMainTableCell>
                    <StyledMainTableCell style={{ padding: '12px 2px', textAlign: 'center' }}>Pickup Date</StyledMainTableCell>
                    <StyledMainTableCell className={`${styles.TableColumn1}`} style={{ padding: '12px 2px', textAlign: 'center' }}>Items</StyledMainTableCell>
                    <StyledMainTableCell className={`${styles.TableColumn2}`} style={{ padding: '12px 2px', textAlign: 'center' }}>Items</StyledMainTableCell>
                    <StyledMainTableCell className={`${styles.TableColumn2}`} style={{ padding: '12px 2px', textAlign: 'center' }}>Loaded</StyledMainTableCell>
                    <StyledMainTableCell className={`${styles.TableColumn2}`} style={{ padding: '12px 2px', textAlign: 'center' }}>Remaining</StyledMainTableCell>
                    <StyledMainTableCell></StyledMainTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {WHFilterItems.length === 0 && (<TableRow>
                    <TableCell colSpan={10} align="center">No data found</TableCell>
                  </TableRow>)}
                  {WHFilterItems?.map((item) => {
                    const isItemSelected = selected1.indexOf(item?.id) !== -1;
                    return <WHItemListCustomRow item={item} addToContainer={addToContainer.bind(this)} addToContainer2={addToContainer2.bind(this)} isItemSelected={isItemSelected} selectRowEvent={selectRowEvent1.bind(this)} />;
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>

        <div className={`${styles.MainCard2Half}  ${styles.MainCard2Half2}`}>
          <p>Container Details</p>

          <div className={`${styles.TableFilterHead}`}>
            <div className={`${styles.SearchBox}`}>
              <TextField
                fullWidth
                placeholder="Search reference, container, forwarder, address or contact..."
                value={filterVars2?.searchKey}
                onChange={(e) => setFilterVars2((prev) => { return { ...prev, searchKey: e.target.value }; })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchOutlined className={styles.SearchIcon} />
                    </InputAdornment>
                  ),
                  endAdornment: filterVars2?.searchKey && (
                    <InputAdornment position="end">
                      <IconButton size="small" aria-label="Clear search" onClick={(e) => setFilterVars2((prev) => { return { ...prev, searchKey: "" }; })}>
                        <ClearRounded fontSize="small" className={styles.ClearButton} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            <div className={styles.DateFilterWrap}>
              <DateRangePicker
                format={"dd/MM/yyyy"}
                placement={"bottomEnd"}
                placeholder="Serach by date"
                caretAs={Calendar}
                value={filterVars2?.date}
                showOneCalendar
                onChange={(e) => setFilterVars2((prev) => { return { ...prev, date: e }; })}
              />
            </div>

            <div className={`${styles.FilerButton}`}>
              <Button className={`${styles.TableAddBU}`} onClick={(e) => removeItemByBookingId()}>Remove All</Button>
            </div>
          </div>

          <div className={`${styles.CusTable}`}>
            <TableContainer component={Paper} elevation={0}>
              <Table sx={{ minWidth: 650 }} aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledMainTableCell padding="checkbox" style={{ padding: '12px 0', width: '34px' }}>
                      <Checkbox
                        className={`${styles.AllCheckbox}`}
                        color="primary"
                        indeterminate={selected2?.length > 0 && selected2?.length < containerFilterItems?.length}
                        checked={containerFilterItems?.length > 0 && selected2?.length === containerFilterItems?.length}
                        onChange={(e) => {
                          if (e.target.checked) {
                            const newSelected = containerFilterItems.map((n) => n.id);
                            setSelected2(newSelected);
                            return;
                          }
                          setSelected2([]);
                        }}
                        disabled={shippingData?.status === 1 || shippingData?.status === "1"}
                      />
                    </StyledMainTableCell>
                    <StyledMainTableCell style={{ padding: '12px 1px', textAlign: 'center' }}>Booking Id</StyledMainTableCell>
                    <StyledMainTableCell style={{ padding: '12px 1px', textAlign: 'center' }}>Pickup Date</StyledMainTableCell>
                    <StyledMainTableCell className={`${styles.TableColumn1}`} style={{ padding: '12px 2px', textAlign: 'center' }}>Items</StyledMainTableCell>
                    <StyledMainTableCell className={`${styles.TableColumn2}`} style={{ padding: '12px 2px', textAlign: 'center' }}>Items</StyledMainTableCell>
                    <StyledMainTableCell className={`${styles.TableColumn2}`} style={{ padding: '12px 2px', textAlign: 'center' }}>Loaded</StyledMainTableCell>
                    <StyledMainTableCell className={`${styles.TableColumn2}`} style={{ padding: '12px 2px', textAlign: 'center' }}>Remaining</StyledMainTableCell>
                    <StyledMainTableCell></StyledMainTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {containerFilterItems.length === 0 && (<TableRow>
                    <TableCell colSpan={10} align="center">No data found</TableCell>
                  </TableRow>)}
                  {containerFilterItems?.map((item) => {
                    const isItemSelected = selected2.indexOf(item?.id) !== -1;
                    return <ConItemListCustomRow item={item} isItemSelected={isItemSelected} removeToContainer={removeToContainer.bind(this)} shippingData={shippingData} removeToContainer2={removeToContainer2.bind(this)} selectRowEvent={selectRowEvent2.bind(this)} />;
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

        </div>
      </div>
    </div>

    <Dialog open={formOpen} onClose={(e) => setFormOpen(false)} fullWidth maxWidth="sm">
      <AddContainerForm onSubmit={onSubmitAddContainerForm.bind(this)} setFormOpen={setFormOpen.bind(this)} setAllData={null} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} editData={editData} />
    </Dialog>

    <Snackbar open={snackOpen} onClose={handleClose} anchorOrigin={{ vertical: "top", horizontal: "right" }} autoHideDuration={3000}>
      <Alert onClose={handleClose} severity="warning" variant="filled" sx={{ width: "100%" }}>{snackMsg}</Alert>
    </Snackbar>

    <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={(e) => setSnackbarOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
      <Alert onClose={(e) => setSnackbarOpen(false)} severity={snackbarType} variant="filled" sx={{ width: "100%" }}>{snackbarMessage}</Alert>
    </Snackbar>
  </>);
};

export default withAdminAuth(AddShipping);